import React, {Component} from 'react';
import Styles from './style.css';
import {BeatLoader} from 'react-spinners';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";

class YieldlockCalculatorSellToLet extends Component {

    constructor(props) {
        super(props);
        this.state = {
            years: 0,
            list_price: 0,
            yield: 0,
            market_price: 0,
            market_rent: 0,
            up_front: false
        };
    };

    componentWillMount() {

    };

    componentDidMount() {
        this.setState({
            years: this.props.years,
            yield: this.props.yield,
            market_price: this.props.market_price,
            market_rent: this.props.market_rent,
            list_rent: this.props.list_rent,
            list_price: this.props.list_price,
            up_front: this.props.up_front
        }, () => {
            try{
                this.props.sellerValueRelese(this.renders.sellerValueRelease());
            }catch (e) {}
        })
    }

    /*
    componentWillReceiveProps(nextProps, nextContext) {
        this.setState({
            years: nextProps.years,
            yield: nextProps.yield,
            market_price: nextProps.market_price,
            market_rent: nextProps.market_rent,
            list_price: nextProps.list_price
        })
    }
    */

    scraper = {};

    init = {};

    functions = {};

    renders = {
        text: (item) => {
            return langRegister.get("booster-industry", item);
        },
        number: (number) => {
            try {
                number = Math.round(number);
                return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
            } catch (e) {
                return ("...")
            }
        },
        format: (num, digits) => {
            var si = [
                { value: 1, symbol: "" },
                { value: 1E3, symbol: "k" },
                { value: 1E6, symbol: "M" },
                { value: 1E9, symbol: "G" },
                { value: 1E12, symbol: "T" },
                { value: 1E15, symbol: "P" },
                { value: 1E18, symbol: "E" }
            ];
            var rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
            var i;
            for (i = si.length - 1; i > 0; i--) {
                if (num >= si[i].value) {
                    break;
                }
            }
            return (num / si[i].value).toFixed(1).replace(rx, "$1") + si[i].symbol;
        },
        years: () => {
            let years = [];
            for(let i = 0; i < this.state.years; i++){
                if(this.props.buyer){
                    years.push({percentage: this.state.yield, year: i + 1, value: this.state.yield * (this.state.list_price / 100)});
                }else{
                    years.push({percentage: this.state.yield, year: i + 1, value: this.state.list_rent, value_list: this.state.yield * (this.state.list_price / 100)});
                }
            }
            if(this.state.up_front && this.props.buyer){
                let value_total = 0;
                let yield_total = 0;
                years.map((item) => {
                    value_total += +item.value;
                    yield_total += +item.percentage;
                    item.value = 0;
                    item.percentage = 0;
                });
                years[0].value = value_total;
                years[0].percentage = yield_total;
            }
            return years;
        },
        upfront: () => {
            let total_yields = 0;
            this.renders.years().map((item) => {
                if(this.props.buyer){
                    total_yields = total_yields + item.value;
                }else{
                    total_yields = total_yields + item.value_list
                }
            });
            return this.state.list_price - total_yields;
        },
        sellerValueRelease: () => {
            let value = this.renders.upfront();
            this.renders.years().map((item) => {
                value = value + +item.value;
            });
            return value;
        },
        sellerValueReleaseHeight: () => {
            if(this.renders.sellerValueRelease() > this.state.market_price){
                return 380;
            } else{
                let difference = this.renders.sellerValueRelease() / this.state.market_price;
                let default_value = (380 * difference);
                return default_value;
            }
        },
        marketPriceHeight: () => {
            if(this.renders.sellerValueRelease() < this.state.market_price){
                return 380*1;
            }  else{
                let difference =  this.state.market_price / this.renders.sellerValueRelease();
                let default_value = (380 * difference);
                return default_value * 1;
            }
        },
        upfrontHeight: () => {
            if(this.renders.sellerValueRelease() > this.state.market_price){
                return (380*(this.renders.upfront()/this.renders.sellerValueRelease())) * 1+'px';
            }else{
                return ((380*(this.renders.upfront()/this.state.market_price)) * 1)+'px';
            }
        },
        yieldlYear: (item) => {
            return (380*(this.renders.sellerValueRelease()/this.state.market_price)*(item.percentage / 100)) * 1+'px';
        }
    };

    render() {
        return (
            <div className={Styles.container}>
                <div className={Styles.bottomSection}>
                    <div className={Styles.bottomSectionBackground}>
                        <img className={Styles.bottomSectionBackgroundItem} src={require("../../assets/images/YS_halo.png")}/>
                    </div>
                    <div style={{bottom: this.renders.marketPriceHeight()+'px'}} className={Styles.bottomSectionMarketBenchMark}>
                        <div className={Styles.bottomSectionMarketBenchMarkText}>
                            <div className={Styles.bottomSectionMarketBenchMarkTextInner}>
                                <div>Confirmed</div>
                                <div>offer</div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.bottomSectionBars}>
                        <div style={{height: (380*1)+'px', display: 'flex', flexDirection: 'column'}}>
                            <div style={{display: 'flex', flex: 1}}/>
                            <div style={{height: this.renders.upfrontHeight()}} className={Styles.bottomSectionBarsSuggestedPrice}>
                                {
                                    false &&
                                    <div className={Styles.bottomSectionBarsSuggestedPriceButtons}>
                                        <div onClick={() => {
                                            this.setState({
                                                yield: this.state.yield - 1
                                            })
                                        }} className={Styles.bottomSectionBarsSuggestedPriceButtonsItem}>
                                            <img className={Styles.sliderInnerContainerCircleMinus} src={require("../../assets/images/plus_sign_white_small.png")}/>
                                        </div>
                                        <div onClick={() => {
                                            this.setState({
                                                yield: this.state.yield + 1
                                            })
                                        }} className={Styles.bottomSectionBarsSuggestedPriceButtonsItem}>
                                            <img className={Styles.sliderInnerContainerCircleMinus} src={require("../../assets/images/minus_icon_white_small.png")}/>
                                        </div>
                                    </div>
                                }
                                {
                                    this.renders.upfront() > this.state.market_price &&
                                    <div className={Styles.bottomSectionBarsSuggestedPriceValue}>
                                        {this.renders.format(this.renders.upfront(), 3)}
                                    </div>
                                }
                                {
                                    this.renders.upfront() <= this.state.market_price &&
                                    <div className={Styles.bottomSectionBarsSuggestedPriceValueBelow}>
                                        {this.renders.format(this.renders.upfront(), 3)}
                                    </div>
                                }
                                <div className={Styles.bottomSectionBarsSuggestedPriceTitle}>
                                    Up-front equity
                                </div>
                            </div>
                        </div>
                        {
                            this.renders.years().length > 0 &&
                            <div className={Styles.bottomSectionBarsSuggesteYears}>
                                <div className={Styles.bottomSectionBarsSuggesteYearsTop}></div>
                                <div className={Styles.bottomSectionBarsSuggesteYearsBottom}>
                                    <div className={Styles.bottomSectionBarsSuggesteYearsMobile}>
                                        {this.renders.format(this.renders.years()[0].value, 3)} x {this.state.years}
                                    </div>
                                    {
                                        this.renders.years().map((item) => {
                                            return (
                                                <div className={Styles.bottomSectionBarsSuggestedYield}>
                                                    <div className={Styles.bottomSectionBarsSuggestedYieldTop}></div>
                                                    <div style={this.renders.sellerValueRelease() < this.state.market_price?{height: this.renders.yieldlYear(item)}:{height: (3.8*item.percentage)*1 + 'px'}} className={Styles.bottomSectionBarsSuggestedYieldBottom}>
                                                        <div className={Styles.bottomSectionBarsSuggestedYieldBottomValue}>
                                                            {this.renders.format(item.value, 3)}
                                                        </div>
                                                        <div className={Styles.bottomSectionBarsSuggestedYieldBottomYear}>
                                                            <div>Year</div>
                                                            <div>{item.year}{
                                                                !this.props.buyer &&
                                                                <span>*</span>
                                                            }</div>
                                                        </div>
                                                    </div>
                                                </div>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        }
                        <div className={Styles.bottomSectionBarsSuggestedSpace}/>
                        <div className={Styles.bottomSectionBarsSuggestedUpfront}>
                            <div className={Styles.bottomSectionBarsSuggestedUpfrontTop}/>
                            <div style={{height: (this.renders.sellerValueReleaseHeight() * 1)+'px'}} className={Styles.bottomSectionBarsSuggestedUpfrontBottom}>
                                {
                                    this.props.buyer &&
                                    <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomValue}>
                                        {this.renders.format(this.state.list_price, 3)}
                                    </div>
                                }
                                {
                                    !this.props.buyer && (this.renders.sellerValueRelease() > this.state.market_price) &&
                                    <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomValue}>
                                        {this.renders.format(this.renders.sellerValueRelease(), 3)}
                                    </div>
                                }
                                {
                                    !this.props.buyer && (this.renders.sellerValueRelease() <= this.state.market_price) &&
                                    <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomValueBelow}>
                                        {this.renders.format(this.renders.sellerValueRelease(), 3)}
                                    </div>
                                }
                                <div className={Styles.bottomSectionBarsSuggestedUpfrontBottomTitle}>
                                    Total value release*
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className={Styles.bottomSectionDivider}/>
                </div>
            </div>
        );
    }
}

export default YieldlockCalculatorSellToLet;


// WEBPACK FOOTER //
// ./src/components/yieldlock-calculator-sell-to-let/component.js